import { createAction, props } from '@ngrx/store';
import { CivicBudgetListItem } from '../../services/civic-budget.common.model';
import {
  CivicBudgetProjectAppEntityCivicBudgetProjectRead,
  CivicBudgetProjectAppEntityCivicBudgetProjectWrite
} from '../../openapi';
import { HttpErrorResponse } from '@angular/common/http';

export const loadBudgets = createAction(
  '[CivicBudget] load budgets',
  props<{ force?: boolean }>()
);

export const loadBudgetsSuccess = createAction(
  '[CivicBudget] load budgets success',
  props<{ budgets: CivicBudgetListItem[] }>()
);

export const loadBudgetsFailure = createAction('[CivicBudget] load budgets failure');

export const submitProject = createAction(
  '[CivicBudget] submit project',
  props<{
    payload: CivicBudgetProjectAppEntityCivicBudgetProjectWrite,
    successFnc: () => void,
    failureFnc: (e: HttpErrorResponse) => void
  }>()
);

export const submitProjectSuccess = createAction(
  '[CivicBudget] submit projectSuccess',
  props<{ project: CivicBudgetProjectAppEntityCivicBudgetProjectRead }>()
);

export const submitProjectFailure = createAction('[CivicBudget] submit project failure');
